'use client';

import { urlMap } from '@nocowanie/core/consts';
import { Logo } from '@nocowanie/common-ui/components/atoms/logo';

import { useAppHeaderHook } from './app-header.hook';

export const AppHeaderLogo = () => {
    const { isMobileRes } = useAppHeaderHook();

    return (
        <Logo
            fill={'brand.solid'}
            logoProps={{
                width: isMobileRes ? 101 : 180,
                height: isMobileRes ? 20 : 36,
            }}
            mt={isMobileRes ? '-3px' : '-4px'}
            url={urlMap.home}
            zIndex={1}
        />
    );
};
